<template>
  <div class="default-img center-me">
    <van-icon name="photo-o" class="default-photo-icon" />
  </div>
</template>

<script>
export default {
  name: "DefaultImage"
};
</script>

<style lang="scss">
.default-img {
  background: #e3e3e3;
  height: 70px;
  width: 70px;
  margin-right: 10px;

  .default-photo-icon {
    color: rgba(69, 90, 100, 0.6);
    font-size: 1.3rem;
  }
}
</style>
